import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Prop, Ref } from "@eastsideco/salvo-ts";
import { elevate, type Autocomplete, type PhraseSuggestion, type ContentItem } from '@apptus/esales-api';
import { VoyadoProductCard } from "./VoyadoProductCard";
import { VoyadoSearchForm } from "./VoyadoSearchForm";

declare global {
    interface Window {
        elevate: ReturnType<typeof elevate>;
    }
}

@Component
export class VoyadoAutocompleteSearch extends ThemeComponent {
    @Ref voyadoSearchForm!: VoyadoSearchForm;
    @Ref relatedSuggestions!: HTMLElement;
    @Ref relatedCollections!: HTMLElement;
    @Ref initialContent!: HTMLElement;
    @Ref noResults!: HTMLElement;
    @Ref results!: HTMLElement;
    @Ref recommendedProducts!: HTMLElement;
    @Ref noResultsTerm!: HTMLElement;
    @Ref closeButton!: HTMLButtonElement;
    @Ref mobileRecommendedProducts!: HTMLElement;

    @Prop({ default: '' }) popularSearches!: string;

    private result?: Autocomplete;

    init() {
        this.$listen(this.closeButton, 'click', () => {
            this.close();
        });

        this.$subscribe(this.voyadoSearchForm.onSearchChange, (result: Autocomplete | undefined) => {
            this.parseResult(result);
        });

        // this.$subscribe(
        //     this.voyadoSearchForm.onShopifyCollectionsLoaded,
        //     (collections: Shopify.Liquid.Collection[]) => {
        //         this.showRelatedCollections(collections);
        //     }
        // );

        document.addEventListener('searchOpen', () => {
            this.open();
        });

        const backdrop = document.querySelector('.voyado-autocomplete-search-backdrop');

        if (backdrop) {
            this.$listen(backdrop as HTMLElement, 'click', () => this.close());
        }
    }

    open() {
        document.body.classList.remove('drawer-open','search-open');
        document.dispatchEvent(new Event('closeMenu'));
        document.dispatchEvent(new Event('hamburgerClose'));

        this.classList.add('voyado-autocomplete-search--open');
        setTimeout(() => this.classList.add('voyado-autocomplete-search--fade-in'), 1);

        this.voyadoSearchForm.querySelector('input')?.focus();

        setTimeout(() => this.classList.add('voyado-autocomplete-search--content-open'), 300);
    }

    close() {
        this.classList.remove('voyado-autocomplete-search--fade-in');
        setTimeout(() => this.classList.remove('voyado-autocomplete-search--open'), 300);
        setTimeout(() => this.classList.remove('voyado-autocomplete-search--content-open'), 300);
        this.voyadoSearchForm.clear();
    }

    parseResult(result: Autocomplete | undefined) {
        this.result = result;

        window.console.log(result);

        if (!this.result) {
            this.showDefaultContent();
        } else if (this.result.totalHits === 0) {
            this.showNoResults();
        } else {
            this.showResults();
        }
    }

    showDefaultContent() {
        this.results.classList.add('voyado-autocomplete-search__results--hidden');
        this.initialContent.classList.remove('voyado-autocomplete-search__initial-content--hidden');
        this.noResults.classList.add('voyado-autocomplete-search__no-results--hidden');
    }

    showNoResults() {
        this.noResultsTerm.innerText = this.voyadoSearchForm.term;

        this.results.classList.add('voyado-autocomplete-search__results--hidden');
        this.initialContent.classList.remove('voyado-autocomplete-search__initial-content--hidden');
        this.noResults.classList.remove('voyado-autocomplete-search__no-results--hidden');
    }

    showResults() {
        this.showRelatedSuggestions();
        this.showRecommendedProducts();
        this.showRelatedCollections();

        this.results.classList.remove('voyado-autocomplete-search__results--hidden');
        this.initialContent.classList.add('voyado-autocomplete-search__initial-content--hidden');
        this.noResults.classList.add('voyado-autocomplete-search__no-results--hidden');
    }

    showRecommendedProducts() {
        const desktopDocumentFragment = document.createDocumentFragment();
        const mobileDocumentFragment = document.createDocumentFragment();

        for (const productGroup of this.result?.productSuggestions || []) {
            const card = new VoyadoProductCard;
            card.productGroup = productGroup;
            desktopDocumentFragment.appendChild(card);
        }

        for (const productGroup of this.result?.productSuggestions || []) {
            const card = new VoyadoProductCard;
            card.productGroup = productGroup;
            mobileDocumentFragment.appendChild(card);
        }

        this.recommendedProducts.replaceChildren(desktopDocumentFragment);
        this.mobileRecommendedProducts.replaceChildren(mobileDocumentFragment);
    }

    showRelatedSuggestions() {
        const suggestionsHTML = this.result?.phraseSuggestions.map(({ q, highlighted }: PhraseSuggestion) => `
                <li>
                    <a href="/search?q=${encodeURI(q)}&origin=PHRASE_SUGGEST">
                        ${highlighted.replace(/\{/g, '<span>').replace(/\}/g, '</span>')}
                    </a>
                </li>
            `).join('');



        this.relatedSuggestions.innerHTML = suggestionsHTML || '';
    }

    showRelatedCollections() {
        const result = this.result?.contentLists.find((item) => item.id === 'with-filtering');
        const collectionsHTML = result?.items.map((item) => `
            <li>
                <a href="${item.link}">
                    ${item.title}
                </a>
            </li>
        `).join('');

        this.relatedCollections.innerHTML = collectionsHTML || '';
    }
}
